import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { HiPlus } from 'react-icons/hi';
import List from 'partial/components/List';
import Button from 'partial/components/Button';
import Pagination from 'partial/components/Pagination';
import MerchantListFilter from './MerchantListFilter';
import { useMerchantList, useSelectMerchant } from '../hooks';
import { useOpenCreateMerchant } from '../modals/CreateMerchantModal';

const MAP_STATUS_LABEL_CLASS = {
  APPROVED: 'text-secondary-800',
  IN_REVIEW: 'text-gray-600',
  PENDING: 'text-yellow-500',
  REJECTED: 'text-danger-600',
};

function MerchantList({ selected, onSelect, add }) {
  const [filter, setFilter] = React.useState({
    keyword: '',
    approval_status: '',
    page: 1,
    sort: 'name:asc',
  });
  const [isLoading, list, pager] = useMerchantList(filter);
  const [openCreateMerchant] = useOpenCreateMerchant();

  const handleOpenAdd = () => {
    openCreateMerchant();
  };
  const renderStatus = React.useCallback(
    (row) => (
      <span
        className={cn(
          'text-[10px]',
          MAP_STATUS_LABEL_CLASS[row.approval_status]
        )}
      >
        {row.approval_status_label}
      </span>
    ),
    []
  );
  React.useEffect(() => {
    if (window.innerWidth <= 1024) return;
    if (!selected && list[0]) onSelect(list[0]);
  }, [selected, list, onSelect]);
  useSelectMerchant(selected?.id);
  return (
    <>
      <div className="bg-white px-6 pt-6 rounded-t-xl">
        <div className="flex">
          <h2 className="text-lg font-medium text-gray-900">List of Billers</h2>
        </div>
        <div className="flex gap-2 mt-2">
          <MerchantListFilter onSubmit={setFilter} value={filter} />
          {add ? (
            <div className="ml-auto">
              <Button size="sm" icon={HiPlus} onClick={handleOpenAdd} primary />
            </div>
          ) : null}
        </div>
      </div>
      <div className="relative flex-grow bg-white rounded-b-xl">
        <div className="absolute h-full w-full top-0 left-0 overflow-auto">
          <List
            label="biller"
            data={list}
            selected={selected}
            onSelect={onSelect}
            isLoading={isLoading}
            subTitleKey={renderStatus}
          />
        </div>
      </div>
      <div className="flex justify-center p-2">
        <Pagination small onChange={setFilter} data={pager} />
      </div>
    </>
  );
}

MerchantList.defaultProps = {
  selected: null,
  add: true,
};

MerchantList.propTypes = {
  selected: PropTypes.instanceOf(Object),
  onSelect: PropTypes.func.isRequired,
  add: PropTypes.bool,
};

export default MerchantList;
